import api from "./api";

export const getsConceptoCobroView = async (filters) => {
    const response = await api.get('/Servicio/GetsConceptoCobroView?'
            + 'idServicio=' + (filters.idServicio == null ? 0 : filters.idServicio)
            + '&idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
            + '&idTipo=' + (filters.idTipo == null ? 0 : filters.idTipo)
            + '&sesionesMes=' + (filters.sesionesMes == null ? 0 : filters.sesionesMes)
            + '&idEstado=' + (filters.idEstado == null ? "" : filters.idEstado)
        );

    return response.data.data;
}

export const getsListServicio = async () => {
    const response = await api.get("/Servicio/GetsListServicio");

    return response.data.data;
}

export const annulConceptoCobro = (idConceptoCobro) =>
    api.post("/Servicio/AnnulConceptoCobro?idConceptoCobro=" + idConceptoCobro);

export const activeConceptoCobro = (idConceptoCobro) =>
    api.post("/Servicio/ActiveConceptoCobro?idConceptoCobro=" + idConceptoCobro);

export const addUpdateConceptoCobro = (dataPost) =>
    api.post("/Servicio/AddUpdateConceptoCobro", dataPost);
